@if (retryConnectionService.messages() && retryConnectionService.messages()?.severity == 'error') {
   <div class="h-[50px] w-full bg-[#e34a00] flex items-center justify-center text-white">{{ retryConnectionService.messages()?.content }}</div>
}
<router-outlet></router-outlet>

<simple-notifications></simple-notifications>

@if (retryConnectionService.messages() && retryConnectionService.messages()?.severity != 'error') {
   <p-message
      styleClass="absolute bottom-[5%] right-[20px] w-[500px] h-[80px] flex gap-5"
      size="large"
      [icon]="retryConnectionService.messages()?.severity != 'error' ? 'pi pi-spin pi-spinner' : 'pi pi-exclamation-triangle'"
      [severity]="retryConnectionService.messages()?.severity"
      >{{ retryConnectionService.messages()?.content }}</p-message
   >
}
